import { useTargetingSelection } from '@/components/Grids/Map/hooks/useTargetingSelection'
import { useAppDispatch, useAppSelector } from '@/redux/hooks/useAppState'
import {
	manualInclusionFiltersSelector,
	setTargetingMetrics,
} from '@/redux/store/slices/grid/gridSlice'
import { ReferenceFields } from 'honeygrid-types'
import { useEffect, useMemo } from 'react'

import { useHouseholdCountFromCells } from './useHouseholdCountFromCells'
import { useTargetedAreaWebsocket } from './useTargetedAreaWebsocket'

export const useTargetingCoverage = () => {
	const { data } = useTargetedAreaWebsocket()
	const targetingSelection = useTargetingSelection(data?.aggregatedDemographics)
	const manualInclusionFilters = useAppSelector(manualInclusionFiltersSelector)
	const dispatch = useAppDispatch()

	const allTargetedCells = useMemo(() => {
		return [...new Set<string>(targetingSelection.concat(manualInclusionFilters ?? []))]
	}, [manualInclusionFilters, targetingSelection])
	// household count for the current targeting selection
	const targetedHouseholdCount = useHouseholdCountFromCells(allTargetedCells)
	// total household count
	const totalHouseholdCount = useHouseholdCountFromCells(
		data?.aggregatedDemographics.sortedCellIds[ReferenceFields.Households] ?? []
	)

	const coverage = totalHouseholdCount > 0 ? targetedHouseholdCount / totalHouseholdCount : 0

	useEffect(() => {
		dispatch(
			setTargetingMetrics({
				households: totalHouseholdCount,
				coverage: Math.round(coverage * 1000),
				targetedHouseholds: targetedHouseholdCount,
			})
		)
	}, [coverage, dispatch, targetedHouseholdCount, totalHouseholdCount])
	return { coverage, targetedHouseholdCount, totalHouseholdCount }
}
